import { render, staticRenderFns } from "./V2DownloadCatalogModalLegacy.vue?vue&type=template&id=46bf0a45&scoped=true&"
import script from "./V2DownloadCatalogModalLegacy.vue?vue&type=script&lang=js&"
export * from "./V2DownloadCatalogModalLegacy.vue?vue&type=script&lang=js&"
import style0 from "./V2DownloadCatalogModalLegacy.vue?vue&type=style&index=0&id=46bf0a45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bf0a45",
  null
  
)

export default component.exports